import { observable, action, computed } from 'mobx';
import { getCaseDatas, getAllTags, findReadme } from '../../api/list';
import { message } from 'antd';
import util from '../../util/index';
import base from '../../tool/base';
import { cloneDeep } from 'lodash';
import { all } from 'promise';

const {
  getAccessToken,
  isMobile,
  getTel,
} = util;

const initState = {
  loading: false,
  caseList: [],
  pageNum: 1,
  pageSize: 6,
  count: 0,
  params: {
    pageNum: 1,
    pageSize: 12,
  },
  otherParams: {},
  searchFormValue: {
    title: "",
    orderby: "createdate",
  },
  tags: [],
  searchLoading: false,
  applyVisible: false,
  applyDemoLoading: false,
  downloadTag: 'total',
  downloadList: [],
  newComment: [],
  workflowInfo: {}, 
  tradeList: [],
  tagsSearch: {
    demotype: 'workflowChart',
    trade: 0,
    function: 0,
  },
  commentValue: "",
  starsLoading: false,
  workflowDetail: {},
  line: true,
  relevant: {},
  detailLoading: false,
  commentParams: {
    pageSize: 10,
    pageNum: 1,
  },
  commentCount: 0,
  // markdownLoading: false,
  // markdownValue: '',
  detailParams: {
    demoId: '',
    appId: '',
  }
};

export default class WorkflowStore {

  routing = null;
  otherParams = initState.otherParams;

  scrollTop = 0;

  @observable params = initState.params;
  @observable loading = initState.loading;
  @observable caseList = initState.caseList;
  @observable pageNum = initState.pageNum;
  @observable pageSize = initState.pageSize;
  @observable count = initState.count;
  @observable searchFormValue = initState.searchFormValue;
  @observable tags = initState.tags;
  @observable searchLoading = initState.searchLoading;
  @observable applyVisible = initState.applyVisible;
  @observable applyDemoLoading = initState.applyDemoLoading;
  @observable downloadTag = initState.downloadTag;
  @observable downloadList = initState.downloadList;
  @observable newComment = initState.newComment;
  @observable workflowInfo = initState.workflowInfo;
  @observable tradeList = initState.tradeList;
  @observable tagsSearch = initState.tagsSearch;
  @observable commentValue = initState.commentValue;
  @observable starsLoading = initState.starsLoading;
  @observable workflowDetail = initState.workflowDetail;
  @observable line = initState.line;
  @observable relevant = initState.relevant;
  @observable detailLoading = initState.detailLoading;
  @observable commentParams = initState.commentParams;
  @observable commentCount = initState.commentCount;
  @observable detailParams = initState.detailParams;
  // @observable markdownLoading = false;
  // @observable markdownValue = '';

  constructor(routing) {
    this.routing = routing;
  }

  @computed
  get getsearchValue() {
    let _searchFormValue = cloneDeep(this.searchFormValue);
    Object.keys(_searchFormValue).map(
      key => {
        _searchFormValue[key] || delete _searchFormValue[key]
      }
    )
    return _searchFormValue;
  }

  @computed
  get tagsList() {
    const {demotype, trade, function: func } = this.tagsSearch;
    let tagsList = {
      demotype: [{
        id: 'allWorkflowForm',
        typeName: '全部',
      },
      {
        id: 'workflowPath',
        typeName: '流程',
      },
      {
        id: 'workflowChart',
        typeName: '表单',
      },
      {
        id: 'workflowStyle',
        typeName: '样式',
      }],
      trade: [],
      function: [],
    }
    tagsList.trade = this.tradeList.map((item) => {
      if(item.key == trade) {
        tagsList.function = item.funcList.map(i => {
          return {
            id: i.key,
            typeName: i.name,
            genreid: item.key,
          }
        })
        if(item.name == '全部') tagsList.function.push(...this.getAllFunction());
      }
      return {
        id: item.key,
        typeName: item.name,
      }
    });
    return tagsList;
  }

  @action
  initDetailParams = () => {
    this.detailParams = initState.detailParams;
  }

  @action
  setDetailParams = (params = {}) => {
    this.detailParams = initState.detailParams;
    Object.keys(params).forEach(key => {
      this.detailParams[key] = params[key];
    });
  }

  @action
  getAllFunction = () => {
    let allFunction = [];
    this.tradeList.map((item) => {
      item.funcList.map(i => {
        i.g_tradeid !== '' && allFunction.push({
          id: i.key,
          typeName: i.name,
          genreid: item.key,
        });
      })
    })
    return allFunction;
  }

  @action
  setState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
    return this;
  }

  @action
  initPage = () => {
    this.params = initState.params;
  }

  @action
  initComment = () => {
    this.setState({
      commentParams: {
        pageSize: 10,
        pageNum: 1,
      },
      commentCount: 0,
      commentValue: '',
      newComment: [],
    });
  }

  @action
  initTagsSearch = () => {
    const { demotype } = this.tagsSearch;
    this.tagsSearch = {
      ...initState.tagsSearch,
      demotype,
    }
  }

  @action
  setSearchValue = (params = {}) => {
    Object.keys(params).forEach(key => {
      this.searchFormValue[key] = params[key];
    });
    return this.searchFormValue;
  }

  @action
  clear = () => this.setState(initState);

  @action
  clearSearchValue = () => this.setState({searchFormValue: initState.searchFormValue});

  @action
  getCaseList = (params, loading)  => {           //获取数据接口
    this.loading = loading !== undefined ? loading : true;
    let tagsSearch = this.tagsSearch;
    const {trade, function: func} = tagsSearch;
    tagsSearch = {
      ...tagsSearch,
      trade: trade == 0 ? '' : trade,
      function: func == 0 ? '' : func,
    }
    params = {
      ...this.params,
      ...this.getsearchValue,
      ...tagsSearch,
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/specifyList', 'GET', params, 'json', 'text').then((data) => {
        try {
          if (data.status) {
            this.caseList = data.demoList;
            this.count = data.count;
          } else {
            console.error('后端接口异常，请联系管理员！');
          }
        } catch (e) {
          console.error('接口错误：', e);
        }
        this.loading = false;
        resolve(data);
      })
    });
  }

  @action
  getDetail = (params = {}, detailLoading = false) => {   //获取单个表单详情
    this.detailLoading = detailLoading;
    params = {
      ...this.detailParams,
      ...params,
      demotype: this.tagsSearch.demotype,
      access_token: getAccessToken(),
    }
    base.callApi('/v5/ecode/demoDetail', 'GET', params, 'json', 'text').then((data) => {
      if (data.status) {
        this.workflowDetail = data.demo;
        this.relevant = data.relevant;
      } else {
        console.error("后端接口异常，请联系管理员！");
      }
      this.detailLoading = false;
    });
  }

  @action
  setStars = (params = {}) => {   //点赞
    params = {
      ...params,
      access_token: getAccessToken(),
    }
    this.starsLoading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/thumbsupAdd', 'POST', params, 'json', 'text').then((data) => {
        if (data.status) {
          // data.msg === '已点赞' ? message.success(data.msg) : message.info(data.msg);
        } else {
          // message.error(data.msg);
        }
        this.starsLoading = false;
        resolve(data);
      });
    })
  }

  @action
  getHotList = (params = {}) => {    //获取热门表单
    params = {
      pageNum: 1,
      pageSize: 10,
      orderBy: this.downloadTag,
      demotype: this.tagsSearch.demotype,
      ...params,
      access_token: getAccessToken(),
    }
    base.callApi('/v5/ecode/hotDemoList', 'GET', params, 'json', 'text').then((data) => {
      if (data.status) {
        this.downloadList = data.hotDemoList;
      } else {
        message.error(data.msg);
      }
    });
  }

  @action
  addComment = (params = {}) => {  //添加评论
    params = {
      ...params,
      access_token: getAccessToken(),
    }
    base.callApi('/v5/ecode/comment/add', 'POST', params, 'json', 'text').then((data) => {
      if (data.status) {
        message.success("评论成功");
        this.getCommentList({appId: params.appId});
        this.setState({commentValue: ''});
      } else {
        message.error(data.msg);
      }
    });
  }

  @action
  getCommentList = (params = {}) => {    //获取评论数据
    params = {
      ...this.commentParams,
      ...params,
      access_token: getAccessToken(),
    }
    base.callApi('/v5/ecode/comment/all', 'GET', params, 'json', 'text').then((data) => {
      if (data.status) {
        this.newComment = data.commentList;
        this.commentCount = data.count;
      } else {
        message.error(data.msg);
      }
    });
  }

  @action
  getTagsList = async params => {   //获取表单行业职能
    this.searchLoading = true;
    base.callApi('/v3/genreNew', 'GET', {}, 'json', 'text').then((data) => {
      try {
        if (data.status) {
          this.tradeList = data.data;
        } else {
          message.error(data.msg);
        }
      } catch(error) {
        console.error('数据格式错误');
      }
    });
    this.searchLoading = false;
  }

  /**
   * 获取md文件信息并添加查看数量
   * @param {string} appId 应用id
   */
  @action
  findReadme = async (appId) => {
    // this.setState({markdownLoading: true});
    const res = await findReadme({
      appId,
    });
    // this.setState({markdownLoading: false});
    try {
      if (res.status) {
        this.setState({ markdownValue: res.readme });
      } else {
        console.error('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.error('接口错误：', e);
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/workflow/WorkflowStore.js